import { render } from "./TieredChallengeSellerCompliance.vue?vue&type=template&id=a1729cb6"
import script from "./TieredChallengeSellerCompliance.vue?vue&type=script&lang=js"
export * from "./TieredChallengeSellerCompliance.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./TieredChallengeSellerCompliance.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_b2e3e009%2Fpackages%2Fstore%2Fsrc%2Fcomponents%2Fchallenge%2Ftiered%2FTieredChallengeSellerCompliance.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__